import * as Sentry from '@sentry/browser'

export default function logError(error, errorInfo?: object) {
  Sentry.captureException(error, errorInfo)
}
